import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full overflow-x-auto border border-[#d8d8e2] rounded-lg" }
const _hoisted_2 = { class: "w-full min-w-[1180px] table-fixed border-collapse" }
const _hoisted_3 = { class: "bg-[#f0f0f4]" }
const _hoisted_4 = { class: "px-3 py-3" }
const _hoisted_5 = { class: "px-3 py-3" }
const _hoisted_6 = { class: "block text-[13px] text-[#16161d] truncate" }
const _hoisted_7 = { class: "px-3 py-3 text-center" }
const _hoisted_8 = { class: "flex flex-col gap-0.5 overflow-hidden" }
const _hoisted_9 = { class: "text-[13px] font-bold text-[#16161d] truncate" }
const _hoisted_10 = {
  key: 0,
  class: "text-[12px] text-[#7f7f8e]"
}
const _hoisted_11 = { class: "px-3 py-3" }
const _hoisted_12 = {
  key: 0,
  class: "flex flex-col items-center gap-1"
}
const _hoisted_13 = {
  class: "text-[13px] text-[#16161d]",
  "data-testid": "handover-accepted-count"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", {
  class: "text-[11px] text-[#7f7f8e]",
  "data-testid": "handover-accepted-label"
}, " aceitaram ", -1)
const _hoisted_15 = ["aria-valuenow", "aria-valuemax", "aria-label"]
const _hoisted_16 = {
  key: 1,
  class: "block text-center text-[13px] text-[#7f7f8e]",
  "data-testid": "handover-accepted-empty"
}
const _hoisted_17 = { class: "px-3 py-3 text-center" }
const _hoisted_18 = { class: "text-[13px] text-[#16161d]" }
const _hoisted_19 = { class: "px-3 py-3 text-center" }
const _hoisted_20 = { class: "text-[13px] text-[#16161d]" }
const _hoisted_21 = { class: "px-3 py-3 text-center" }
const _hoisted_22 = { class: "flex justify-center" }
const _hoisted_23 = { class: "px-3 py-3 text-center" }
const _hoisted_24 = { class: "flex justify-center" }

import { format, parseISO } from 'date-fns'
import { AdminQueueResponse } from '@/Network/Types/Responses/HandoverInviteResponses'
import { InviteStatus, PackageStatus } from '@/Network/Types/Requests/HandoverInviteRequests'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import HandoverExpirationBadge from './HandoverExpirationBadge.vue'
import HandoverStatusBadge from './HandoverStatusBadge.vue'
import DoctorInfo from '@/components/DoctorInfo.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'HandoverApprovalsTable',
  props: {
    items: {}
  },
  emits: ["evaluate", "view-candidates", "view-details"],
  setup(__props: any) {





const columns = [
  { key: 'requester', label: 'Profissional que está passando', width: 'w-[230px]' },
  { key: 'schedule', label: 'Escala', width: 'w-[160px]' },
  { key: 'healthUnit', label: 'Unidade', width: 'w-[170px]' },
  { key: 'candidates', label: 'Profissionais que querem assumir', width: 'w-[150px]' },
  { key: 'inviteDate', label: 'Data do convite', width: 'w-[110px]' },
  { key: 'shifts', label: 'Plantões', width: 'w-[90px]' },
  // O header "Expiração" reflete o caso padrão da fila (badge de prazo); quando o
  // filtro de status traz pacotes fora da fila, a célula mostra o badge de status.
  { key: 'status', label: 'Expiração', width: 'w-[140px]' },
  { key: 'actions', label: 'Ações', width: 'w-[130px]' }
]

const isInAdminQueue = (item: AdminQueueResponse) =>
  item.package.status === PackageStatus.IN_ADMIN_QUEUE

const getInviteCount = (item: AdminQueueResponse) => item.package.invites.length

const getAcceptedCount = (item: AdminQueueResponse) =>
  item.package.invites.filter((invite) => invite.status === InviteStatus.ACCEPTED).length

const getAcceptedPercent = (item: AdminQueueResponse) => {
  const total = getInviteCount(item)
  return total === 0 ? 0 : Math.round((getAcceptedCount(item) / total) * 100)
}

// Um pacote em transição não tem o que avaliar, mas tem quem cobrar.
const canViewCandidates = (item: AdminQueueResponse) =>
  item.package.status === PackageStatus.PENDING && getInviteCount(item) > 0

// Um convite pode agrupar plantões de unidades diferentes — exibimos a primeira
// e sinalizamos as demais com um contador.
const getHealthUnitNames = (item: AdminQueueResponse) => {
  const names = item.package.stations
    .map((station) => station.healthUnit?.name)
    .filter((name): name is string => !!name)
  return [...new Set(names)]
}

const getHealthUnitName = (item: AdminQueueResponse) => getHealthUnitNames(item)[0] ?? ''

const getExtraHealthUnitsCount = (item: AdminQueueResponse) =>
  Math.max(getHealthUnitNames(item).length - 1, 0)

const formatDate = (dateStr: string) => {
  try {
    return format(parseISO(dateStr), 'dd/MM/yyyy')
  } catch {
    return dateStr
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", _hoisted_3, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columns, (col) => {
            return _createElementVNode("th", {
              key: col.key,
              class: _normalizeClass(["px-3 py-2.5 text-[13px] font-bold text-[#272735] text-center leading-tight align-middle", col.width])
            }, _toDisplayString(col.label), 3)
          }), 64))
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: item.package.id,
            class: "border-t border-[#e8e8ed] bg-white hover:bg-[#fafafa] transition-colors"
          }, [
            _createElementVNode("td", _hoisted_4, [
              _createVNode(DoctorInfo, {
                name: item.package.requester.name,
                subtitle: `CRM ${item.package.requester.crm}`,
                "avatar-url": item.package.requester.avatarUrl,
                "nps-score": item.package.requester.npsScore,
                size: "sm"
              }, null, 8, ["name", "subtitle", "avatar-url", "nps-score"])
            ]),
            _createElementVNode("td", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(item.package.schedule.name), 1)
            ]),
            _createElementVNode("td", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(getHealthUnitName(item) || '-'), 1),
                (getExtraHealthUnitsCount(item) > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, " +" + _toDisplayString(getExtraHealthUnitsCount(item)) + " unidade" + _toDisplayString(getExtraHealthUnitsCount(item) > 1 ? 's' : ''), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("td", _hoisted_11, [
              (getInviteCount(item) > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("span", _hoisted_13, _toDisplayString(getAcceptedCount(item)) + " de " + _toDisplayString(getInviteCount(item)), 1),
                    _hoisted_14,
                    _createElementVNode("div", {
                      class: "h-1 w-16 overflow-hidden rounded-full bg-[#e2e2e9]",
                      role: "progressbar",
                      "aria-valuenow": getAcceptedCount(item),
                      "aria-valuemin": "0",
                      "aria-valuemax": getInviteCount(item),
                      "aria-label": `${getAcceptedCount(item)} de ${getInviteCount(
                  item
                )} convidados aceitaram`
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["h-full rounded-full transition-[width] duration-300", getAcceptedCount(item) > 0 ? 'bg-[#198038]' : '']),
                        style: _normalizeStyle({ width: getAcceptedPercent(item) + '%' }),
                        "data-testid": "handover-accepted-progress"
                      }, null, 6)
                    ], 8, _hoisted_15)
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_16, " — "))
            ]),
            _createElementVNode("td", _hoisted_17, [
              _createElementVNode("span", _hoisted_18, _toDisplayString(formatDate(item.package.createdAt)), 1)
            ]),
            _createElementVNode("td", _hoisted_19, [
              _createElementVNode("span", _hoisted_20, _toDisplayString(item.package.stations.length), 1)
            ]),
            _createElementVNode("td", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                (isInAdminQueue(item))
                  ? (_openBlock(), _createBlock(HandoverExpirationBadge, {
                      key: 0,
                      "expires-at": item.package.expiresAt
                    }, null, 8, ["expires-at"]))
                  : (_openBlock(), _createBlock(HandoverStatusBadge, {
                      key: 1,
                      status: item.package.status
                    }, null, 8, ["status"]))
              ])
            ]),
            _createElementVNode("td", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                (isInAdminQueue(item))
                  ? (_openBlock(), _createBlock(OutlineButton, {
                      key: 0,
                      text: "Avaliar",
                      width: "auto",
                      height: "revert-layer",
                      "data-testid": "handover-evaluate-button",
                      onClick: ($event: any) => (_ctx.$emit('evaluate', item))
                    }, null, 8, ["onClick"]))
                  : (canViewCandidates(item))
                    ? (_openBlock(), _createBlock(OutlineButton, {
                        key: 1,
                        text: "Ver convidados",
                        width: "auto",
                        height: "revert-layer",
                        "data-testid": "handover-view-candidates-button",
                        onClick: ($event: any) => (_ctx.$emit('view-candidates', item))
                      }, null, 8, ["onClick"]))
                    : (_openBlock(), _createBlock(OutlineButton, {
                        key: 2,
                        text: "Detalhes",
                        width: "auto",
                        height: "revert-layer",
                        "data-testid": "handover-detail-button",
                        onClick: ($event: any) => (_ctx.$emit('view-details', item))
                      }, null, 8, ["onClick"]))
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})